<template>
  <v-ons-page>
    <v-ons-toolbar>
      <div class="center">
        <img id="ellafashion-logo" src="../assets/ellafashion.png" alt="EllaFashion">
      </div>
    </v-ons-toolbar>
    <v-ons-list>
      <v-ons-list-item modifier="chevron" v-for="item in menu" 
        @click="$emit('menu', item.link)" :key="item.link">
        <div class="left"><v-ons-icon fixed-width :icon="item.icon"></v-ons-icon></div>
        <div class="center">{{ item.label }}</div>
      </v-ons-list-item>
    </v-ons-list>
    <div style="text-align: center">
      <img id="mariella-logo" src="../assets/mariella.png" alt="MariElla">
    </div>
  </v-ons-page>
</template>

<script>
const items = [
  ["fa-home", "Home", "/"],
  ["fa-plus", "Add labels", "/add"],
  ["fa-minus", "Remove labels", "/del"],
  ["fa-tag", "Check label", "/label"],
  ["fa-gift", "Check product", "/product/"],
  ["fa-sign-out", "Logout", "/logout"]
];
const menu = items.map(i => ({ icon: i[0], label: i[1], link: i[2] }));
export default {
  name: 'menu-page',
  data: () => ({ menu })
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ons-list-title {
  text-transform: none;
}
ons-list-item {
  cursor: pointer;
}
#ellafashion-logo {
  width: 150px;
  position: relative;
  top: 3px;
}
#mariella-logo { 
  max-width: 150px; 
  margin-top: 1rem;
  
}
</style>



// WEBPACK FOOTER //
// src/pages/MenuPage.vue